import ApisService from './index'

export const listSubAdmin = () => ApisService.get('/sub-admin/list')
export const getSubAdminScopeTree = () => ApisService.get('/sub-admin/scope-tree')
export const assignSubAdmin = (userId: number, duAnIds: number[]) =>
  ApisService.post('/sub-admin/assign', { userId, duAnIds })
export const removeSubAdminDuAn = (userId: number, duAnId: number) =>
  ApisService.delete(`/sub-admin/${userId}/duan/${duAnId}`)
export const removeSubAdminHeThong = (userId: number, hethongId: number) =>
  ApisService.delete(`/sub-admin/${userId}/hethong/${hethongId}`)
export const removeSubAdmin = (userId: number) =>
  ApisService.delete(`/sub-admin/${userId}`)
